require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-upgrade-reason-syntax.json") })
        }
      }, "path---package-upgrade-reason-syntax");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-upgrade-reason-syntax!./.cache/json/package-upgrade-reason-syntax.json
// module id = 974
// module chunks = 231608221292675